import { useState, useEffect, useCallback } from 'react';

export function useScrollPosition(threshold = 80) {
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY >= threshold);
		};

		window.addEventListener('scroll', handleScroll);
		handleScroll();

		return () => window.removeEventListener('scroll', handleScroll);
	}, [threshold]);

	return isScrolled;
}

export function useMobileMenu() {
	const [isOpened, setIsOpened] = useState(false);

	const toggle = useCallback(() => {
		setIsOpened((prev) => !prev);
	}, []);

	const close = useCallback(() => {
		setIsOpened(false);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			setIsOpened(false);
		};

		document.onscroll = handleScroll;

		return () => {
			document.onscroll = null;
		};
	}, []);

	useEffect(() => {
		const main = document.querySelector('main');
		if (!main) return;

		const closeMenu = () => setIsOpened(false);

		main.addEventListener('click', closeMenu);
		main.addEventListener('focusin', closeMenu);

		return () => {
			main.removeEventListener('click', closeMenu);
			main.removeEventListener('focusin', closeMenu);
		};
	}, []);

	return { isOpened, toggle, close };
}

export function useMenuFilterEffect(isOpened: boolean) {
	useEffect(() => {
		const main = document.querySelector('main');
		if (!main) return;

		main.style.filter = isOpened ? 'brightness(0.5)' : 'brightness(1)';

		return () => {
			main.style.filter = 'brightness(1)';
		};
	}, [isOpened]);
}
